import useReveal from "../hooks/useReveal";

/**
 * FeatureSection.jsx
 * - matches the four-column "core features" look from your screenshots
 * - responsive: 1 column on mobile, 2 on tablet, 4 on large screens
 */

const features = [
  {
    title: "One-tap checklist sharing",
    desc: "Send perfectly formatted loan checklists instantly. No copy-paste. No confusion. No repeated questions.",
    icon: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" className="flex-none">
        <rect x="1" y="3" width="22" height="18" rx="3" stroke="white" strokeOpacity="0.9" strokeWidth="1.2" />
        <path d="M7 10.5l2.5 2L17 7" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: "Loan stage management",
    desc: "Define custom stages and clear progress indicators for each customer.",
    icon: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
        <rect x="3" y="4" width="6" height="16" rx="2" stroke="white" strokeWidth="1.2" />
        <rect x="10.5" y="7" width="6" height="13" rx="2" stroke="white" strokeWidth="1.2" />
        <rect x="18" y="10" width="3" height="10" rx="2" stroke="white" strokeWidth="1.2" />
      </svg>
    ),
  },
  {
    title: "Share history & analytics",
    desc: "Track shares, pending documents, customer responses, and conversion timings.",
    icon: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="9" stroke="white" strokeWidth="1.2" />
        <path d="M8 12l2-2 2 4 4-6" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: "Multi-role access",
    desc: "Separate dashboards and permissions for DSAs, agents, agencies and bank users.",
    icon: (
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
        <path d="M12 12a3 3 0 100-6 3 3 0 000 6z" stroke="white" strokeWidth="1.2" />
        <path d="M4 20c1.5-3 5-5 8-5s6.5 2 8 5" stroke="white" strokeWidth="1.2" strokeLinecap="round" />
      </svg>
    ),
  },
];

export default function FeatureSection() {
    // hook returns a ref + "visible" class when element is in view
    const [ref, visible] = useReveal({ threshold: 0.18, rootMargin: "-40px" });
  return (
    <section id="features" className="features py-16 bg-white/0">

      <div
          ref={ref}
          className={`container max-w-7xl mx-auto px-6 ${
            visible ? "animate-fade-up" : "opacity-0 translate-y-6"
          }`}>
        <h2 className="text-2xl md:text-3xl font-extrabold text-center mb-6">Core features</h2>
        <p className="text-center text-lg lp-muted max-w-2xl mx-auto mb-10">
          Everything your team needs — from one-tap sharing to role-based workflows and analytics.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((f) => (
            <article key={f.title} className="lp-card flex flex-col h-full">
              <div className="flex items-center gap-4 mb-4" aria-hidden>
                <div className="w-12 h-12 rounded-lg bg-white/6 flex items-center justify-center">{f.icon}</div>
                <h3 className="text-lg font-semibold text-white">{f.title}</h3>
              </div>

              <p className="text-sm text-white/90 mb-4" style={{lineHeight:1.6}}>{f.desc}</p>

              
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
